var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-progreess-component"},[_c('div',{staticClass:"rate",style:({'width': (_vm.percentage < 0 ? 0 : _vm.percentage > 100 ? 100 : _vm.percentage) + '%'})}),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }